import { useState, useEffect, useRef } from 'react';
import { Search, AlertTriangle, Info, Wifi, RefreshCw, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, ChevronDown, ChevronUp, TableOfContents, Trash2, CalendarDays, Columns3, CirclePlus, Monitor, Download, Check, Copy, X, Trash, CircleEllipsis, Key, Loader2, User, ArrowBigUp, Settings, Server, Bot } from 'lucide-react';

import { Modal } from "@mui/material";
// import { jwt_decode } from '../utlis/jwt_decode';
import { useNavigate } from 'react-router-dom';
import ScrollContainer from 'react-indiana-drag-scroll';
import { createPortal } from "react-dom";
import SubnetModal from './AgentSubnet/SubnetModal';

import { showError, showSuccess } from '../../utils/toast';
import baseapi from '../../services/baseapi';
// Removed CustomDropdown import as it is unused
import { ItemsPerPageDropdown } from '../../components/ItemsPerPageDropdown ';
import RescanModal from './AgentRescanModal';
import { hasPermission } from '../../utils/permissionsHelper';
// Removed SingleSelectApiDropdown import as it is unused
import AgentExportModal from './AgentExportModal';


// interface SubnetModalProps {
//     agent?: any
//     open: boolean;
//     onClose: () => void;
// }

// interface SubnetData {
//     name: string;
//     subnet: string;
//     description: string;
//     enabled: boolean;
//     priority: number;
//     excludeIPs: string[];
//     ports: number[];
// }

type ColumnKey =
    | 'hostname'
    | 'ip_address'
    | 'mac_address'
    | 'status'
    | 'version'
    | 'platform'
    | 'architecture'
    | 'tags'
    | 'last_seen'
    | 'agent_type'
    | 'client_name'
    | 'actions';




const AgentsTable = ({ clientId }: { clientId?: number }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [selectedOS, setSelectedOS] = useState<'windows' | 'linux' | 'darwin' | 'arm'>('linux');
    const [showColumnSettings, setShowColumnSettings] = useState(false);
    const [agentData, setAgentData] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    // const decodedToken = jwt_decode();
    const [copiedStates, setCopiedStates] = useState<{
        install: boolean;
        reinstall: boolean;
        uninstall: boolean;
    }>({
        install: false,
        reinstall: false,
        uninstall: false
    });
    const storedLevel = localStorage.getItem('level');
    const level = storedLevel ? JSON.parse(storedLevel) : null;
    // const clientId = level.client_id;
    // const organizationId = decodedToken.organization_id;
    // const [deleteAgent, setDeleteAgent] = useState<any>({})
    // const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const [showInstallModal, setShowInstallModal] = useState(false);
    //pagination states and vars
    const [totalItems, setTotalItems] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(30);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const [install_agentType] = useState<any>("master")

    const [installCommand, setInstallCommand] = useState<string>("");
    const [loadingCommand, setLoadingCommand] = useState<boolean>(false);
    const [selectedProbeAgent, setSelectedProbeAgent] = useState<any>(null);
    const [customPort, setCustomPort] = useState<string>("");

    const [showRescanModal, setShowRescanModal] = useState(false);
    const [modalJobTypes, setModalJobTypes] = useState<{ value: string; label: string; }[] | undefined>(undefined);
    const [selectedAgent, setSelectedAgent] = useState<any>(null);

    const [unistallModalOpen, setUnistallModalOpen] = useState(false)
    const [uninstallAgent, setUninstallAgent] = useState<any>({})

    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const menuDropdownRef = useRef<HTMLDivElement | null>(null);
    const [showExportModal, setShowExportModal] = useState(false);
    const canCreate = hasPermission('agents', 'create')
    const canDelete = hasPermission('agents', 'delete')
    const canEdit = hasPermission('agents', 'update')

    const fetchMasterCommand = async () => {
        setLoadingCommand(true);
        try {
            const response = await baseapi.get('/agents/install/master', {
                params: {
                    client_id: clientId,
                    api_url: window.location.origin,
                    domain: window.location.origin,
                    platform: selectedOS
                }
            });
            if (response.data.command) {
                setInstallCommand(response.data.command);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingCommand(false);
        }
    };

    const fetchLightweightCommand = async (agentId?: string) => {
        setLoadingCommand(true);

        try {
            const params: any = {
                client_id: clientId,
                platform: selectedOS
            };
            if (agentId) params.agent_id = agentId;

            const response = await baseapi.get('/agents/install/lightweight', {
                params
            });
            if (response.data.command) {
                setInstallCommand(response.data.command);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingCommand(false);
        }
    };

    // Removed useEffect that forced lightweight for windows/darwin as it should be master always

    useEffect(() => {
        if (!showInstallModal) {
            setInstallCommand("");
            setSelectedProbeAgent(null);
            setCustomPort("");
            return;
        }

        if (install_agentType === 'master') {
            setSelectedProbeAgent(null);
            fetchMasterCommand();
        } else if (install_agentType === 'lightweight') {
            fetchLightweightCommand(selectedProbeAgent?.id);
        }
    }, [install_agentType, showInstallModal, selectedOS, selectedProbeAgent]);


    //sorting
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);
    const isSortable = (key: string) => !['actions', 'tags'].includes(key);
    const [showSubnetModal, setShowSubnetModal] = useState(false);
    // const [showCredsModal, setShowCredsModal] = useState(false);

    const isFirstSearch = useRef(true);


    // Column visibility state
    const [columnVisibility, setColumnVisibility] = useState<Record<ColumnKey, boolean>>({
        hostname: true,
        ip_address: true,
        mac_address: true,
        status: true,
        version: true,
        platform: true,
        architecture: true,
        tags: true,
        last_seen: true,
        actions: true,
        agent_type: true,
        client_name: true,

    });

    const dropdownRef = useRef<HTMLDivElement>(null);

    //permissions


    const fetchData = async (
        skip: number = (currentPage - 1) * itemsPerPage || 0, limit: number = itemsPerPage || 30,
        orderBy: Record<string, 'asc' | 'desc'>[] = [{ name: 'desc' }]) => {
        try {
            setLoading(true)

            const [sortEntry] = orderBy;
            const sort_by = Object.keys(sortEntry)[0];
            const sort_order = sortEntry[sort_by];


            const effectiveClientId = clientId || level?.id;
            const queryObj: any = {
                ...(effectiveClientId ? { client_id: effectiveClientId } : {}),
            };

            if (debouncedSearch) {
                queryObj.$or = [
                    { hostname: { "$ilike": `%${debouncedSearch}%` } },
                    { ip_address: { "$ilike": `%${debouncedSearch}%` } },
                    { name: { "$ilike": `%${debouncedSearch}%` } }
                ];
            }

            const params = {
                query: JSON.stringify(queryObj),

                skip: skip,
                limit: limit,
                sort_by: sort_by,
                sort_order: sort_order
            }

            try {
                const response = await baseapi.get('/agents', { params })
                // const response ={data:{status: false}}
                if (response.data.status) {
                    setAgentData(response.data.data)
                    setLoading(false)
                    setTotalPages(Math.ceil(response.data.total / limit))
                    setTotalItems(response.data.total)
                } else {
                    // Fallback to mock data
                    setAgentData([])
                    setTotalPages(0)
                    setTotalItems(0)
                    setLoading(false)
                }
            } catch (apiError) {
                console.warn('API call failed, using mock data:', apiError);
                // Use mock data as fallback
                setAgentData([])
                setTotalPages(0)
                setTotalItems(0)
                setLoading(false)
            }
        }
        catch (error: any) {
            showError(error.message)
            // Fallback to mock data
            setAgentData([])
            setTotalPages(0)
            setTotalItems(0)
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Debounce search term
    useEffect(() => {
        const handler = setTimeout(() => {
            if (debouncedSearch !== searchTerm) {
                setDebouncedSearch(searchTerm);
                setCurrentPage(1);
            }
        }, 500);
        return () => clearTimeout(handler);
    }, [searchTerm, debouncedSearch]);

    // Re-fetch when debouncedSearch changes
    useEffect(() => {
        if (isFirstSearch.current) {
            isFirstSearch.current = false;
            return;
        }
        fetchData(0, itemsPerPage);
    }, [debouncedSearch]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowColumnSettings(false);
            }
            if (menuDropdownRef.current && !menuDropdownRef.current.contains(event.target as Node)) {
                setOpenMenuId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleRefresh = () => {
        setSearchTerm('');
        setDebouncedSearch('');
        setCurrentPage(1);
        fetchData();
    };

    // const filteredData = agentData.filter((item: any) =>
    //     item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.hostname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.ip_address?.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const copyToClipboard = async (text: any, _fieldName: any) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    const handleRescanSubmit = async (data: any) => {
        try {
            const response = await baseapi.post('/agents/agent-task', data);
            if (response.data.status) {
                showSuccess(response.data.message);
                // Optionally refresh the agent data
                fetchData();
            } else {
                showError(response.data.message);
            }
        } catch (error: any) {
            showError(error.message);
        }
    };


    const getStatusColor = (status: string) => {
        switch (status) {
            case 'online': return 'text-green-400';
            case 'offline': return 'text-red-500';
            case 'busy': return 'text-yellow-400';
            case 'error': return 'text-red-400';
            case 'maintenance': return 'text-blue-400';
            default: return 'text-gray-100';
        }
    };

    const getStatusBg = (status: string) => {
        switch (status) {
            case 'online': return 'bg-green-400';
            case 'offline': return 'bg-red-500';
            case 'busy': return 'bg-yellow-400';
            case 'error': return 'bg-red-400';
            case 'maintenance': return 'bg-blue-400';
            default: return 'bg-gray-400';
        }
    };


    const getPlatformIcon = (platform: string) => {
        switch (platform) {
            case 'windows': return '/windows.png';
            case 'linux': return '/linux.svg';
            case 'darwin': return '/mac.png';
            default: return null;
        }
    };

    const toggleColumn = (columnName: ColumnKey) => {
        setColumnVisibility(prev => ({
            ...prev,
            [columnName]: !prev[columnName]
        }));
    };

    const toggleAllColumns = () => {
        const allVisible = Object.values(columnVisibility).every(visible => visible);

        const newVisibility: Record<ColumnKey, boolean> = Object.keys(columnVisibility).reduce((acc, key) => {
            acc[key as ColumnKey] = !allVisible;
            return acc;
        }, {} as Record<ColumnKey, boolean>);

        setColumnVisibility(newVisibility);
    };

    const handleSort = (key: string) => {
        setSortConfig((prev) => {
            if (prev?.key === key) {
                const newDirection = prev.direction === 'asc' ? 'desc' : 'asc';
                fetchData((currentPage - 1) * itemsPerPage, itemsPerPage, [{ [key]: newDirection }]);
                return { key, direction: newDirection };
            } else {
                fetchData((currentPage - 1) * itemsPerPage, itemsPerPage, [{ [key]: 'asc' }]);
                return { key, direction: 'asc' };
            }
        });
    };

    //pagination functions
    const handlePageChange = (page: number): void => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            fetchData((itemsPerPage * (page - 1)), itemsPerPage)
        }
    };

    const handleItemsPerPageChange = (value: number): void => {
        setItemsPerPage(value);
        setCurrentPage(1);
        fetchData(0, value)
    };



    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setDropdownPosition({
            top: rect.bottom + 1,
            left: rect.right - 160, // adjust for alignment
        });
        setOpenMenuId(openMenuId === id ? null : id);
    };





    // const handleDelete = async (agent_id: string) => {
    //     try {
    //         const response = await baseapi.delete(`/agents/${agent_id}`)
    //         if (response.data.status) {
    //             showSuccess(response.data.message)
    //             fetchData()
    //         }
    //         else {
    //             showError(response.data.message)
    //         }
    //     }
    //     catch (error: any) {
    //         showError(error.message)
    //     }
    // };

    // const handleAgentClick = (agentId: any, client_id: any) => {
    //     localStorage.setItem('ids', JSON.stringify({ 'agent_id': agentId, client_id: client_id, 'path': "/agents/results" }))
    //     navigate("/agents/dashboard")
    // }

    const handleCopy = async (text: string, type: 'install' | 'reinstall' | 'uninstall'): Promise<void> => {
        try {
            await navigator.clipboard.writeText(text);

            // Show checkmark animation
            setCopiedStates(prev => ({ ...prev, [type]: true }));
            showSuccess(`${type.charAt(0).toUpperCase() + type.slice(1)} command copied!`);

            // Reset after animation
            setTimeout(() => {
                setCopiedStates(prev => ({ ...prev, [type]: false }));
            }, 1500);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const baseColumns: {
        key: ColumnKey;
        label: string;
        icon: React.ElementType;
        color: string;
    }[] = [

            { key: 'ip_address', label: 'IP Address', icon: Wifi, color: 'text-green-400' },
            { key: 'hostname', label: 'Hostname', icon: Server, color: 'text-blue-400' },
            { key: 'agent_type', label: 'Agent Type', icon: Bot, color: 'text-indigo-400' },
            { key: 'platform', label: 'Platform', icon: Server, color: 'text-indigo-400' },
            { key: 'version', label: 'Version', icon: Info, color: 'text-cyan-400' },
            { key: 'architecture', label: 'Architecture', icon: Info, color: 'text-pink-400' },
            { key: 'status', label: 'Status', icon: AlertTriangle, color: 'text-yellow-400' },
            { key: 'client_name', label: 'Client Name', icon: User, color: 'text-gray-100' },
            { key: 'last_seen', label: 'Updated', icon: CalendarDays, color: 'text-gray-100' },
            { key: 'actions', label: 'Action', icon: TableOfContents, color: 'text-gray-100' },
        ];

    const columns = baseColumns.filter((col) => {
        // hide actions if no permission
        if (col.key === "actions" && !(canDelete || canEdit)) return false;

        // hide client_name if not global level
        if (col.key === "client_name" && level.name !== "global") return false;

        return true;
    });

    return (
        <div className="bg-white p-3 pb-20 min-h-screen">
            <div className="w-full mx-auto">
                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-2">
                    <div className="flex items-center gap-1.5">
                        <div className="bg-[#422568] p-1.5 rounded shadow-lg">
                            <Monitor className="w-4 h-4 text-white" />
                        </div>
                        <div>
                            <h1 className="font-bold text-lg text-slate-800 leading-none">Agents</h1>
                        </div>
                        {!loading &&
                            <div className='font-bold text-lg text-slate-800'>
                                ({totalItems})
                            </div>
                        }

                    </div>

                    {/* Search and Controls */}
                    <div className="flex items-center gap-2">
                        {/* Column Settings */}
                        <button
                            onClick={handleRefresh}
                            disabled={loading}
                            className="rounded-lg bg-white border border-slate-200 text-slate-600 p-2 hover:bg-slate-50 transition-colors shadow-sm"
                        >
                            <RefreshCw className={`w-3.5 h-3.5 ${loading ? 'animate-spin' : ''}`} />
                        </button>

                        <div className="relative w-full sm:w-56">
                            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400 w-3.5 h-3.5" />
                            <input
                                type="text"
                                placeholder="Search agents..."
                                className="w-full bg-slate-50 border border-slate-200 rounded-lg pl-8 pr-3 py-1.5 text-[11px] text-slate-800 placeholder-slate-400 focus:border-[#422568] focus:ring-1 focus:ring-[#422568] outline-none transition-all shadow-sm"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>

                        <div className="relative" ref={dropdownRef} data-col-menu>
                            <button
                                onClick={() => setShowColumnSettings(!showColumnSettings)}
                                className="p-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 text-slate-600 transition-all flex items-center gap-2 shadow-sm"
                            >
                                <Columns3 className="w-3.5 h-3.5" />
                                <span className="text-[10px] font-bold uppercase tracking-wider">Columns</span>
                            </button>

                            {/* Dropdown */}
                            {showColumnSettings && (
                                <div className="absolute top-full mt-2 right-0 w-52 bg-white border border-slate-200 rounded-xl shadow-2xl z-[110] p-1.5 max-h-[450px] overflow-y-auto">
                                    <div className="px-3 py-1.5 text-[9px] font-extrabold text-slate-800 uppercase border-b border-slate-100 mb-1 flex items-center justify-between">
                                        <span>Toggle Columns</span>
                                        <button
                                            onClick={toggleAllColumns}
                                            className="text-[9px] text-[#422568] hover:text-[#422568] transition-colors"
                                        >
                                            {Object.values(columnVisibility).every(Boolean)
                                                ? 'Hide All'
                                                : 'Show All'}
                                        </button>
                                    </div>
                                    {columns.map(({ key, label, icon: Icon, color }) => (
                                        <button
                                            key={key}
                                            onClick={() => toggleColumn(key)}
                                            className="w-full flex items-center justify-between px-3 py-2 text-[10px] font-bold uppercase text-slate-600 hover:bg-slate-50 rounded-lg transition-colors"
                                        >
                                            <div className="flex items-center gap-2.5">
                                                <Icon className={`w-3 h-3 ${columnVisibility[key] ? color : 'text-slate-300'}`} />
                                                {label}
                                            </div>
                                            <div className={`w-3 h-3 rounded border flex items-center justify-center transition-colors ${columnVisibility[key] ? 'bg-[#422568] border-[#422568]' : 'border-slate-200'}`}>
                                                {columnVisibility[key] && <Check className="w-2.5 h-2.5 text-white" />}
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>


                        {canCreate && (
                            <button
                                onClick={() => setShowInstallModal(true)}
                                className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-lg px-4 py-1.5 text-[11px] text-slate-800 font-bold hover:bg-slate-50 transition-all shadow-sm"
                            >
                                <Download className="w-4 h-4 text-[#422568]" />
                                Install
                            </button>
                        )}

                        {/* <button
                            onClick={() => setShowExportModal(true)}
                            className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-lg px-4 py-1.5 text-[11px] text-slate-800 font-bold hover:bg-slate-50 transition-all shadow-sm"
                        >
                            <Download className="w-4 h-4 text-cyan-500" />
                            Export
                        </button> */}

                        {/* {(level?.name !== 'global' && canCreate) && (
                            <button
                                className="flex items-center gap-1.5 bg-[#422568] rounded-lg px-4 py-1.5 text-[11px] text-white font-bold hover:bg-[#422568] shadow-lg shadow-[#422568]/20 transition-all"
                                onClick={() => navigate('/agents/add')}
                            >
                                <CirclePlus className="w-4 h-4" />
                                Add Agent
                            </button>
                        )} */}
                        {/* 
                        <CustomDropdown
                            data={agent_type_vals}
                            width="w-42"
                            placeholder="All Status"
                            selectedValue={agentType}
                            onSelect={setAgentType}
                            buttonHeight={8}
                        /> */}
                    </div>
                </div>

                <SubnetModal
                    agent={selectedAgent}
                    open={showSubnetModal}
                    onClose={() => setShowSubnetModal(false)}
                />



                {/* Table */}
                <div className="bg-white border border-slate-200 rounded-t-xl overflow-hidden shadow-sm">
                    <ScrollContainer
                        className="overflow-x-auto custom-scroll cursor-grab active:cursor-grabbing"
                        horizontal={true}
                        vertical={false}
                        hideScrollbars={false}
                    >
                        <table className="w-full text-left text-xs border-collapse">
                            <thead className="bg-slate-50 sticky top-0 z-10">
                                <tr className="border-b border-slate-200">
                                    {columns.map(({ key, label, icon: Icon, color }) =>
                                        columnVisibility[key] ? (
                                            <th
                                                key={key}
                                                onClick={() => key !== 'actions' && key !== 'tags' && handleSort(key)}
                                                className={`px-1 py-3 text-[10px] font-extrabold text-slate-800 uppercase tracking-widest select-none whitespace-nowrap ${key === 'actions' ? 'text-left sticky right-0 bg-slate-50 z-10' : 'text-center cursor-pointer'
                                                    }`}
                                            >
                                                <div className={`flex items-center gap-2 justify-center`}>
                                                    <Icon className={`w-3.5 h-3.5 ${color}`} />
                                                    {label}
                                                    {isSortable(key) && (
                                                        sortConfig?.key === key ? (
                                                            sortConfig.direction === 'asc' ? (
                                                                <ChevronUp size={12} />
                                                            ) : (
                                                                <ChevronDown size={12} />
                                                            )
                                                        ) : (
                                                            <ChevronDown size={12} />
                                                        )
                                                    )}
                                                </div>
                                            </th>
                                        ) : null
                                    )}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {agentData.length === 0 && !loading ? (
                                    <tr>
                                        <td colSpan={Object.values(columnVisibility).filter(Boolean).length} className="py-16 text-center text-slate-400 font-bold uppercase tracking-widest italic">
                                            No agents found
                                        </td>
                                    </tr>
                                ) : loading ? (
                                    <tr>
                                        <td colSpan={Object.values(columnVisibility).filter(Boolean).length} className="py-16 text-center text-slate-400 font-bold uppercase tracking-widest italic">
                                            <div className="flex items-center justify-center gap-2">
                                                <Loader2 className="w-4 h-4 animate-spin text-[#422568]" />
                                                Loading agents
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    agentData.map((item: any, _index: any) => (
                                        <tr
                                            key={item.id}
                                            className="hover:bg-slate-50/80 transition-colors group border-b border-slate-100"
                                        >
                                            {columnVisibility.ip_address && (
                                                <td className="px-1 py-0.5 font-mono text-center">
                                                    <div className="flex items-center justify-center gap-2 group/copy">
                                                        <button

                                                            className="text-blue-500 text-[11px] font-bold leading-none">
                                                            {item.ip_address || '-'}
                                                        </button>
                                                        {item.ip_address && (
                                                            <button
                                                                onClick={() => copyToClipboard(item.ip_address, `ip-${item.id}`)}
                                                                className="opacity-0 group-hover/copy:opacity-100 transition-opacity"
                                                                title="Copy IP address"
                                                            >
                                                                <Copy className="w-2.5 h-2.5 text-gray-100 hover:text-white" />
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            )}

                                            {columnVisibility.hostname && (
                                                <td className="px-1 py-0.5 font-mono text-center">
                                                    <div className="flex items-center justify-center gap-2 group/copy">
                                                        <span className="text-slate-800 text-[10px] leading-none truncate max-w-[200px] font-bold" title={item.hostname || '-'}>
                                                            {item.hostname || '-'}
                                                        </span>
                                                        {item.hostname && (
                                                            <button
                                                                onClick={() => copyToClipboard(item.hostname, `hostname-${item.id}`)}
                                                                className="opacity-0 group-hover/copy:opacity-100 transition-opacity"
                                                                title="Copy hostname"
                                                            >
                                                                <Copy className="w-2.5 h-2.5 text-slate-400 hover:text-slate-600" />
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            )}

                                            {columnVisibility.agent_type && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <span className="text-[10px] text-slate-600 font-bold capitalize">
                                                            {item.agent_type === 'lightweight' ? 'End Point agent' : (item.agent_type || '-')}
                                                        </span>
                                                    </div>
                                                </td>
                                            )}

                                            {columnVisibility.platform && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <div className="flex items-center justify-center gap-2">
                                                        {getPlatformIcon(item.platform) && (
                                                            <img src={getPlatformIcon(item.platform) || ''} alt={item.platform} className="w-4 h-4" />
                                                        )}
                                                        <span className="text-[10px] text-slate-600 font-bold capitalize">
                                                            {item.platform || '-'}
                                                        </span>
                                                    </div>
                                                </td>
                                            )}

                                            {columnVisibility.version && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <span className="text-[10px] text-slate-600 font-bold font-mono">
                                                        {item.version || '-'}
                                                    </span>
                                                </td>
                                            )}

                                            {columnVisibility.architecture && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <span className="text-[10px] text-slate-600 font-bold">
                                                        {item.architecture || '-'}
                                                    </span>
                                                </td>
                                            )}

                                            {columnVisibility.status && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <div
                                                        className="inline-flex items-center gap-2 px-2.5 py-0.5 rounded-full border border-slate-200 bg-slate-50 relative group"
                                                    >
                                                        {/* Status Dot */}
                                                        <div className={`w-1.5 h-1.5 rounded-full ${getStatusBg(item.status)}`}></div>

                                                        {/* Status Text */}
                                                        <span
                                                            className={`text-[9px] font-extrabold uppercase tracking-wide ${getStatusColor(item.status)}`}
                                                        >
                                                            {item.status}
                                                        </span>

                                                        {/* Tooltip (only if last_pinged_time exists) */}
                                                        {item.last_pinged_time && (
                                                            <div className="absolute bottom-full left-0 mb-1 hidden group-hover:block bg-slate-800 text-white text-[9px] rounded px-2 py-1 whitespace-nowrap z-10 shadow-xl">
                                                                <div>Last pinged</div>
                                                                <div>{new Date(item.last_pinged_time).toLocaleString()}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            )}


                                            {columnVisibility.client_name && (level.name === 'global') && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <span className="text-[10px] text-slate-800 font-bold">
                                                        {item?.client_name}
                                                    </span>
                                                </td>
                                            )}

                                            {columnVisibility.last_seen && (
                                                <td className="px-1 py-0.5 text-center">
                                                    <span className="text-[10px] text-slate-600 font-bold">
                                                        {item?.last_seen
                                                            ? new Date(item.last_seen).toLocaleString(undefined, {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                year: "numeric",
                                                                month: "short",
                                                                day: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}
                                                    </span>
                                                </td>
                                            )}

                                            {columnVisibility.actions && (canDelete || canEdit) && (
                                                <td className="px-1 py-0.5 whitespace-nowrap text-center text-xs font-medium sticky right-0 z-10 bg-white group-hover:bg-slate-50 transition-colors">
                                                    <div className="flex items-center justify-center space-x-2 relative">
                                                        <div className="relative">
                                                            <button
                                                                onClick={(e) => handleMenuOpen(e, item.id)} // ✅ Correct call
                                                                className="text-[#422568] hover:text-[#422568] p-1 rounded-full hover:bg-white transition-colors flex items-center cursor-pointer border border-transparent shadow-sm hover:border-slate-200"
                                                            >
                                                                <CircleEllipsis className="w-4 h-4" />
                                                            </button>

                                                            {openMenuId === item.id &&
                                                                createPortal(
                                                                    <div
                                                                        ref={menuDropdownRef} // ✅ this enables outside click detection
                                                                        className="mt-2 w-40 bg-white border border-slate-200 rounded-lg shadow-2xl z-[9999] overflow-hidden"
                                                                        style={{
                                                                            top: dropdownPosition.top,
                                                                            left: dropdownPosition.left,
                                                                            position: "fixed",
                                                                        }}
                                                                    >
                                                                        {(item.agent_type) === "lightweight" ? (
                                                                            <>
                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            setSelectedAgent(item);
                                                                                            if (item.is_ad_server) {
                                                                                                setModalJobTypes([
                                                                                                    { value: 'local_asset_scan', label: 'Lightweight Scan' },
                                                                                                    { value: 'ad_scan', label: 'AD Scan' }
                                                                                                ]);
                                                                                            } else {
                                                                                                setModalJobTypes([
                                                                                                    { value: 'local_asset_scan', label: 'Lightweight Scan' }
                                                                                                ]);
                                                                                            }
                                                                                            setShowRescanModal(true);
                                                                                            setOpenMenuId(null);
                                                                                        }}
                                                                                        className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-[#422568] hover:text-white flex items-center gap-2"
                                                                                    >
                                                                                        <RefreshCw className="w-4 h-4 text-white" />
                                                                                        Scan
                                                                                    </button>)}
                                                                                {canDelete && (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            setUnistallModalOpen(true);
                                                                                            setUninstallAgent(item);
                                                                                            setOpenMenuId(null);
                                                                                        }}
                                                                                        className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-[#422568] flex items-center gap-2"
                                                                                    >
                                                                                        <Trash className="w-4 h-4 text-red-400" />
                                                                                        Uninstall
                                                                                    </button>)}
                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleRescanSubmit({
                                                                                                agent_id: item.id,
                                                                                                job_type: "update_agent",
                                                                                                parameters: {},
                                                                                                // client_id: item.client_id,
                                                                                            });
                                                                                            setOpenMenuId(null);
                                                                                        }}
                                                                                        className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-[#422568] flex items-center gap-2"
                                                                                    >
                                                                                        <ArrowBigUp className="w-4 h-4 text-[#422568]" />
                                                                                        Update
                                                                                    </button>)}


                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            setSelectedAgent(item);
                                                                                            setModalJobTypes(undefined);
                                                                                            setShowRescanModal(true);
                                                                                            setOpenMenuId(null);
                                                                                        }}
                                                                                        className="group w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-[#422568] hover:text-white flex items-center gap-2"
                                                                                    >
                                                                                        <RefreshCw className="w-4 h-4 text-[#422568] group-hover:text-white" />
                                                                                        Scan
                                                                                    </button>)}

                                                                                {canDelete && (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            setUnistallModalOpen(true);
                                                                                            setUninstallAgent(item);
                                                                                            setOpenMenuId(null);
                                                                                        }}
                                                                                        className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-[#422568] hover:text-white flex items-center gap-2"
                                                                                    >
                                                                                        <Trash className="w-4 h-4 text-red-400" />
                                                                                        Delete
                                                                                    </button>)}

                                                                                {/* <button
                                                                                    onClick={() => {
                                                                                        setSelectedAgent(item);
                                                                                        setShowSubnetModal(true)
                                                                                        setOpenMenuId(null);
                                                                                    }}
                                                                                    className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-gray-700 flex items-center gap-2"
                                                                                >
                                                                                    <Network className="w-4 h-4 text-blue-400" />
                                                                                    Subnet Config
                                                                                </button> */}

                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            navigate(`/agent-credentials/${item.id}?client_id=${item.client_id}`);
                                                                                            setOpenMenuId(null);
                                                                                        }}
                                                                                        className="w-full text-left px-3 py-2 text-sm text-gray-800 hover:bg-slate-50 flex items-center gap-2 transition-colors"
                                                                                    >
                                                                                        <Key className="w-4 h-4 text-blue-500" />
                                                                                        Credentials Config
                                                                                    </button>
                                                                                )}

                                                                            </>
                                                                        )}
                                                                    </div>,
                                                                    document.body
                                                                )}

                                                        </div>
                                                    </div>
                                                </td>
                                            )}

                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </ScrollContainer>
                </div>


                {/* Table Footer */}
                <div className="bg-slate-50 border rounded-b-xl border-slate-200 px-2 py-2 flex items-center justify-between shadow-sm">
                    <div className="flex items-center gap-4">
                        <ItemsPerPageDropdown
                            value={itemsPerPage}
                            onChange={(val: any) => handleItemsPerPageChange(val)}
                        />
                        <span className="text-[10px] text-slate-500 font-extrabold uppercase tracking-widest">
                            <span className="text-slate-800">{startIndex + 1}</span> - <span className="text-slate-800">{Math.min(endIndex, totalItems)}</span> OF {totalItems}
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="p-1.5 text-slate-400 hover:text-slate-800 transition-colors disabled:opacity-30"><ChevronsLeft className="w-4 h-4" /></button>
                        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-1.5 text-slate-400 hover:text-slate-800 transition-colors disabled:opacity-30"><ChevronLeft className="w-4 h-4" /></button>
                        <div className="px-3 py-1 bg-[#422568] rounded-lg text-white text-[11px] font-extrabold mx-1.5 shadow-lg shadow-[#422568]/20">{currentPage}</div>
                        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-1.5 text-slate-400 hover:text-slate-800 transition-colors disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
                        <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="p-1.5 text-slate-400 hover:text-slate-800 transition-colors disabled:opacity-30"><ChevronsRight className="w-4 h-4" /></button>
                    </div>
                </div>
            </div>

            <Modal open={showInstallModal} onClose={() => setShowInstallModal(false)}>
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
        w-[90%] sm:w-[520px] max-w-lg bg-white 
        border border-slate-200 shadow-2xl p-6 rounded-2xl text-slate-800
        relative overflow-hidden">

                    {/* Subtle top border */}
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#422568] via-[#422568] to-[#422568]"></div>

                    {/* Header */}
                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center">
                            <div className="w-10 h-10 bg-[#422568] rounded-xl flex items-center justify-center mr-3">
                                <Download className='h-6 w-6 text-white' />
                            </div>
                            <h2 className="text-xl font-extrabold text-slate-800 tracking-tight">Install Agent</h2>
                        </div>
                        <button
                            onClick={() => setShowInstallModal(false)}
                            className="p-2 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-all"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>

                    {/* OS Selection Tabs */}
                    <div className="flex mb-6 bg-slate-50 rounded-xl p-1 border border-slate-200">
                        {/* <button
                            onClick={() => setSelectedOS('windows')}
                            disabled={install_agentType === 'master'}
                            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2 px-2 rounded-lg transition-all ${install_agentType === 'master' ? 'opacity-30 cursor-not-allowed grayscale' : ''} ${selectedOS === 'windows'
                                ? 'bg-white border border-slate-200 text-[#422568] shadow-sm'
                                : 'text-slate-500 hover:text-slate-800'
                                }`}
                        >
                            <img src="/windows.png" alt="Windows" className="w-6 h-6" />
                            <span className="text-[10px] font-bold uppercase">Windows</span>
                        </button> */}
                        <button
                            onClick={() => setSelectedOS('linux')}
                            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2 px-2 rounded-lg transition-all  ${selectedOS === 'linux'
                                ? 'bg-white border border-slate-200 text-[#422568] shadow-sm'
                                : 'text-slate-500 hover:text-slate-800'
                                }`}
                        >
                            <img src="/linux.svg" alt="Linux" className="w-6 h-6" />
                            <span className="text-[10px] font-bold uppercase">Linux</span>
                        </button>
                        {/* <button
                            onClick={() => setSelectedOS('darwin')}
                            disabled={install_agentType === 'master'}
                            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2 px-2 rounded-lg transition-all ${install_agentType === 'master' ? 'opacity-30 cursor-not-allowed grayscale' : ''} ${selectedOS === 'darwin'
                                ? 'bg-white border border-slate-200 text-[#422568] shadow-sm'
                                : 'text-slate-500 hover:text-slate-800'
                                }`}
                        >
                            <img src="/mac.png" alt="Darwin" className="w-6 h-6" />
                            <span className="text-[10px] font-bold uppercase">Mac</span>
                        </button> */}
                        <button
                            onClick={() => setSelectedOS('arm')}
                            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2 px-2 rounded-lg transition-all  ${selectedOS === 'arm'
                                ? 'bg-white border border-slate-200 text-[#422568] shadow-sm'
                                : 'text-slate-500 hover:text-slate-800'
                                }`}
                        >
                            <img src="/raspberrypi.svg" alt="Arm" className="w-6 h-6" />
                            <span className="text-[10px] font-bold uppercase">Arm</span>
                        </button>
                    </div>

                    {/* Agent Type removed - default to master */}

                    {/* Command Sections */}
                    <div className="space-y-6">
                        {/* Install Command */}
                        <div>
                            <div className="flex items-center justify-between mb-3">

                                <span className="text-sm font-bold text-slate-800 flex items-center uppercase tracking-wide text-[11px]">
                                    <CirclePlus className="w-4 h-4 mr-2 text-green-600" />
                                    Install Command
                                </span>

                                <button
                                    onClick={() => {
                                        if (installCommand) {
                                            handleCopy(installCommand + (customPort ? ` --port ${customPort}` : ''), 'install');
                                        }
                                    }}
                                    className={`flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-bold transition-all ${copiedStates.install ? 'bg-green-50 text-green-600 border border-green-200' : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border border-slate-200'}`}
                                >
                                    {copiedStates.install ? <Check size={14} /> : <Copy size={14} />}
                                    {copiedStates.install ? 'Copied' : 'Copy'}
                                </button>
                            </div>

                            {install_agentType === 'master' && (
                                <div className='text-[10px] text-[#422568] font-bold uppercase mb-2 flex items-center gap-1'>
                                    <Info size={12} />
                                    Master agent defaults to port 9847
                                </div>
                            )}

                            <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 group relative">
                                {loadingCommand ? (
                                    <div className="flex items-center gap-2 text-slate-400 italic text-sm">
                                        <Loader2 className="w-4 h-4 animate-spin" />
                                        Generating unique command...
                                    </div>
                                ) : (
                                    <code className="text-slate-700 font-mono text-xs block break-all leading-relaxed font-bold">
                                        {installCommand}{customPort ? ` --port ${customPort}` : ''}
                                    </code>
                                )}
                            </div>

                            {install_agentType === 'master' && (
                                <div className="mt-3">
                                    <div className="flex items-center gap-2 mb-2">
                                        <Settings size={14} className="text-slate-400" />
                                        <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Custom Port (Optional)</span>
                                    </div>
                                    <input
                                        type="number"
                                        placeholder="e.g. 8080"
                                        className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:border-[#422568] focus:ring-1 focus:ring-[#422568] outline-none transition-all shadow-sm"
                                        value={customPort}
                                        onChange={(e) => setCustomPort(e.target.value)}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Uninstall Command */}
                        <div>
                            <div className="flex items-center justify-between mb-3 pt-4 border-t border-slate-100">
                                <span className="text-sm font-bold text-slate-800 flex items-center uppercase tracking-wide text-[11px]">
                                    <Trash2 className="w-4 h-4 mr-2 text-red-600" />
                                    Uninstall Command
                                </span>
                                <button
                                    onClick={() => {
                                        const uninstallCmd = selectedOS === 'windows' ? './ovulscanner.exe -u' : selectedOS === 'darwin' ? './ovulscanner_darwin -u' : './ovulscanner_linux -u';
                                        handleCopy(uninstallCmd, 'uninstall');
                                    }}
                                    className={`flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-bold transition-all ${copiedStates.uninstall ? 'bg-green-50 text-green-600 border border-green-200' : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border border-slate-200'}`}
                                >
                                    {copiedStates.uninstall ? <Check size={14} /> : <Copy size={14} />}
                                    {copiedStates.uninstall ? 'Copied' : 'Copy'}
                                </button>
                            </div>
                            <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
                                <code className="text-slate-700 font-mono text-xs block font-bold">
                                    {selectedOS === 'windows' ? './ovulscanner.exe -u' : selectedOS === 'darwin' ? './ovulscanner_darwin -u' : './ovulscanner_linux -u'}
                                </code>
                            </div>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="flex justify-end mt-8">
                        <button
                            onClick={() => setShowInstallModal(false)}
                            className="px-6 py-2.5 bg-[#422568] text-white rounded-xl text-sm font-extrabold hover:bg-slate-900 transition-all shadow-lg shadow-slate-200"
                        >
                            Done
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal open={unistallModalOpen} onClose={() => setUnistallModalOpen(false)}>
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
              w-[95%] sm:w-[500px] md:w-[550px] max-w-2xl bg-white 
              border border-slate-200 shadow-2xl p-6 rounded-2xl text-slate-800
              relative overflow-hidden">

                    {/* Subtle top border */}
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-500 via-red-600 to-red-500"></div>

                    {/* Header */}
                    <div className="flex items-center mb-6">
                        <div className="w-12 h-12 bg-red-50 rounded-2xl flex items-center justify-center mr-4 text-red-600">
                            <Trash2 className='h-7 w-7' />
                        </div>
                        <div>
                            <h2 className="text-2xl font-extrabold text-slate-800 tracking-tight">Confirm Uninstall</h2>
                            <p className="text-slate-500 text-xs font-bold uppercase tracking-wider">Dangerous Action</p>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="mb-8 bg-slate-50 p-4 rounded-xl border border-slate-200 space-y-4">
                        <p className="text-slate-800 text-lg font-bold">
                            Are you sure you want to uninstall <span className="text-[#422568] underline decoration-[#422568]/50 underline-offset-4">{uninstallAgent?.name}</span>?
                        </p>
                        <div className="flex items-start gap-3 bg-red-50 p-3 rounded-lg border border-red-100">
                            <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0" />
                            <p className="text-red-700 text-sm font-bold leading-relaxed">
                                Warning: All assets, scan results, and configuration data associated with this agent will be permanently purged.
                            </p>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-3 justify-end">
                        <button
                            onClick={() => setUnistallModalOpen(false)}
                            className="px-6 py-3 border border-slate-200 text-slate-600 rounded-xl
              hover:bg-slate-50 hover:text-slate-800
              transition-all duration-200 font-extrabold text-sm min-w-[120px]"
                        >
                            Keep Agent
                        </button>
                        <button
                            onClick={() => {
                                handleRescanSubmit({
                                    agent_id: uninstallAgent?.id,
                                    job_type: 'uninstall_agent',
                                    parameters: {}, // Empty parameters object
                                    client_id: uninstallAgent?.client_id
                                });
                                setUnistallModalOpen(false);
                            }}
                            className="px-6 py-3 bg-red-600 text-white rounded-xl font-extrabold text-sm
              hover:bg-red-700 hover:shadow-lg hover:shadow-red-200
              transition-all duration-200 min-w-[120px]"
                        >
                            Confirm Uninstall
                        </button>
                    </div>
                </div>
            </Modal>

            <SubnetModal
                agent={selectedAgent}
                open={showSubnetModal}
                onClose={() => setShowSubnetModal(false)}
            />

            <AgentExportModal
                isOpen={showExportModal}
                onClose={() => setShowExportModal(false)}
                templateName="agents"
                clientId={level?.id}
            />

            {/* Rescan Modal */}
            <RescanModal
                open={showRescanModal}
                onClose={() => setShowRescanModal(false)}
                onSubmit={handleRescanSubmit}
                agent={selectedAgent}
                customJobTypes={modalJobTypes}
            />



        </div>
    );
};

export default AgentsTable;
